const s = ["success", "error", "info"], t = [
  "start-x",
  "end-x",
  "start-y",
  "end-y"
];
export {
  t as TOAST_ANIMATION,
  s as TOAST_STATUS
};
